import { Box, Button } from "@mui/material";
import { Link as LinkIcon } from "lucide-react";
import type { Transaction } from "../../lib/types";

export function RecordEditorActions({
  transaction,
  isArchived,
  confirmDelete,
  canRestoreRecurringDueDate,
  recurringDueDateLabel,
  pending,
  onCancelDelete,
  onDelete,
  onRestore,
  onUnlink,
  onOpenLinkPicker,
}: {
  transaction: Transaction | null;
  isArchived: boolean;
  confirmDelete: boolean;
  canRestoreRecurringDueDate: boolean;
  recurringDueDateLabel: string;
  pending: {
    save: boolean;
    delete: boolean;
    restore: boolean;
    unlink: boolean;
  };
  onCancelDelete: () => void;
  onDelete: (restoreRecurringDueDate?: boolean) => void;
  onRestore: () => void;
  onUnlink: () => void;
  onOpenLinkPicker: () => void;
}) {
  const canLink = Boolean(transaction && !isArchived && !transaction.linked_transaction_id && transaction.type !== "correction");
  return (
    <Box className="records-modal-actions">
      {confirmDelete ? (
        <Box className="record-delete-confirm">
          {canRestoreRecurringDueDate ? (
            <p>
              This record was created from a recurring payment. Delete it only, or also move the recurring payment back to {recurringDueDateLabel}?
            </p>
          ) : null}
          <Box className="record-delete-confirm-actions">
            <Button variant="outlined" type="button" disabled={pending.delete} onClick={onCancelDelete}>
              Cancel
            </Button>
            {canRestoreRecurringDueDate ? (
              <Button variant="outlined" color="error" type="button" disabled={pending.delete} onClick={() => onDelete(false)}>
                Delete only
              </Button>
            ) : null}
            <Button variant="outlined" color="error" type="button" disabled={pending.delete} onClick={() => onDelete(canRestoreRecurringDueDate)}>
              {canRestoreRecurringDueDate ? "Delete and move due date back" : isArchived ? "Confirm delete forever" : "Confirm delete"}
            </Button>
          </Box>
        </Box>
      ) : isArchived ? (
        <>
          <Button variant="outlined" color="error" type="button" disabled={pending.delete} onClick={() => onDelete()}>
            Delete forever
          </Button>
          <Button variant="outlined" type="button" disabled={pending.restore} onClick={onRestore}>
            Restore record
          </Button>
        </>
      ) : (
        <>
          {transaction ? (
            <Button variant="outlined" color="error" type="button" disabled={pending.delete} onClick={() => onDelete()}>
              Delete record
            </Button>
          ) : null}
          {transaction?.linked_transaction_id ? (
            <Button variant="outlined" type="button" disabled={pending.unlink} onClick={onUnlink}>
              Unlink transfer
            </Button>
          ) : null}
          {canLink ? (
            <Button variant="outlined" type="button" startIcon={<LinkIcon size={16} />} onClick={onOpenLinkPicker}>
              Link transaction
            </Button>
          ) : null}
          <Button variant="contained" type="submit" disabled={pending.save}>
            {transaction ? "Save changes" : "Create record"}
          </Button>
        </>
      )}
    </Box>
  );
}
